import { useMutation, useQuery } from '@tanstack/react-query';

import { accountUserDetailKey } from '../common/queryKeys';
import AccountUserApi from '../../../../../lib/api/account/user/AccountUserApi';
import { setRequestForm } from '../../../../../lib/common';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { ACCOUNT_USER_DETAIL_POINT_HISTORY_LIST_FILTER_OPTION_MODEL } from './models';
import AppApi from '../../../../../lib/api/app/AppApi';
import { ACCOUNT_USER_DETAIL_USER_PERSONAL_INFO_MODEL } from '../AccountUserDetailUserInfo/models';

export const useAccountUserPointDetailQuery = ({ userId, options }) => {
  return useQuery(
    [...accountUserDetailKey, 'pointDetail', userId],
    async () => {
      const result = await AccountUserApi.getAccountUserPointDetail(
        setRequestForm(
          {
            userId,
            pointHistory: {
              filterOption: ACCOUNT_USER_DETAIL_POINT_HISTORY_LIST_FILTER_OPTION_MODEL,
              pagination: LIST_PAGINATION_MODEL,
            },
          },
          true,
        ),
      );
      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
      initialData: {
        data: {
          userInfo: ACCOUNT_USER_DETAIL_USER_PERSONAL_INFO_MODEL,
          pointCauseSelectList: [],
        },
      },
    },
  );
};

export const useAccountUserDetailPointListQuery = ({ userId, pagination, filterOption, options }) => {
  return useQuery(
    [...accountUserDetailKey, 'pointDetail', 'list', pagination, filterOption, userId],
    async () => {
      const result = await AccountUserApi.getAccountUserDetailPointList(
        setRequestForm({ userId, filterOption, pagination }, true),
      );
      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
      initialData: {
        data: {
          pointHistoryList: {
            list: [],
            totalCnt: 0,
          },
        },
      },
    },
  );
};

export const useCheckValidGeneratePointMutate = ({ options }) => {
  return useMutation(
    [...accountUserDetailKey, 'pointDetail', 'valid'],
    async (selectedUserInfoList) => {
      const result = await AppApi.checkValidGeneratePoint(setRequestForm({ selectedUserInfoList }, true));
      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
    },
  );
};
